/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Toggle_HideInputs */

const en_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Subtitle Styling`)
};

const fr_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer le style des sous-titres`)
};

const de_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelformatierung ausblenden`)
};

const it_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi stile sottotitoli`)
};

const ru_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть стиль субтитров`)
};

const es_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar el estilo de los subtítulos`)
};

const zh_cn2_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏副标题样式`)
};

const ja_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕スタイルを非表示`)
};

const hi_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक शैली को छुपाएँ`)
};

const pt_pt2_image_export_style_toggle_hide = /** @type {(inputs: Image_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar estilo de legenda`)
};

/**
* | output |
* | --- |
* | "Hide Subtitle Styling" |
*
* @param {Image_Export_Style_Toggle_HideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_toggle_hide = /** @type {((inputs?: Image_Export_Style_Toggle_HideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Toggle_HideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_toggle_hide(inputs)
	if (locale === "de") return de_image_export_style_toggle_hide(inputs)
	if (locale === "it") return it_image_export_style_toggle_hide(inputs)
	if (locale === "ru") return ru_image_export_style_toggle_hide(inputs)
	if (locale === "es") return es_image_export_style_toggle_hide(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_toggle_hide(inputs)
	if (locale === "ja") return ja_image_export_style_toggle_hide(inputs)
	if (locale === "hi") return hi_image_export_style_toggle_hide(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_toggle_hide(inputs)
	return en_image_export_style_toggle_hide(inputs)
});